import { ModuleWithProviders } from "@angular/core";
import { ConfigOption, FormlyModule } from "@ngx-formly/core";
import { RepeatFormComponent } from "../../components/formly/types/repeat-form/repeat-form.component";
import { TableTypeComponent } from "../../components/formly/types/table-type/table-type.component";
import { TimeTypeComponent } from "../../components/formly/types/time-type/time-type.component";
import { InputLabelWrapper } from "../../components/formly/wrappers/input-label-wrapper/input-label-wrapper";
import { SectionFormWrapper } from "../../components/formly/wrappers/section-form-wrapper/section-form-wrapper";
import { FormlyValidations } from "../../validation/formly/formly-validation";
import { FormlyValidationsMessages } from "../../validation/formly/formly-validation.message";
import { WebserviceTypeComponent } from "../../components/formly/types/webservice-type/webservice-type.component";

const ConfigOptionsFormlyProvider: ConfigOption = {
    validators: FormlyValidations,
    wrappers: [
        { name: 'section', component: SectionFormWrapper },
        { name: 'label', component: InputLabelWrapper },
    ],
    types: [
        // Field Types //
        { name: 'number', extends: 'input', defaultOptions: { props: { type: 'number' } } },
        { name: 'time', component: TimeTypeComponent },

        // Field Arrays //
        { name: 'repeat', component: RepeatFormComponent },
        { name: 'table', component: TableTypeComponent },
        { name: 'webservice', component: WebserviceTypeComponent }
    ],
    validationMessages: FormlyValidationsMessages
}

export const FormlyProvider: ModuleWithProviders<FormlyModule> = FormlyModule.forRoot(ConfigOptionsFormlyProvider)

